import './_styles.scss';
import React from 'react';
import { Rating } from 'components';

const ProductRating = ({ score=1, onSelect }) => (
  <div className='product-rating' onClick={onSelect}>
    <Rating score={score}/>
    <div className="Suffix">& Up</div>
  </div>
);

export default () => {
  return (
    <div className="filter-group rating-filter">

      <div className="Heading">Product Rating</div>

      <ProductRating score={5} onSelect={() => onchange(5)}/>
      <ProductRating score={4} onSelect={() => onchange(4)}/>
      <ProductRating score={3} onSelect={() => onchange(3)}/>
      <ProductRating score={2} onSelect={() => onchange(2)}/>
      <ProductRating score={1} onSelect={() => onchange(1)}/>

    </div>
  )
}
